var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelatorio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6562 8.4375V17.0312H11.7188V2.96875H17.1875V6.875C17.1875 7.2894 17.3521 7.68683 17.6451 7.97985C17.9382 8.27288 18.3356 8.4375 18.75 8.4375H22.6562ZM19.5312 3.15781L22.4672 6.09375H19.5312V3.15781ZM10.9375 0.625C10.5231 0.625 10.1257 0.78962 9.83265 1.08265C9.53962 1.37567 9.375 1.7731 9.375 2.1875H6.25C5.8356 2.1875 5.43817 2.35212 5.14515 2.64515C4.85212 2.93817 4.6875 3.3356 4.6875 3.75H1.5625C1.1481 3.75 0.750671 3.91462 0.457646 4.20765C0.16462 4.50067 0 4.8981 0 5.3125L0 14.6875C0 15.1019 0.16462 15.4993 0.457646 15.7924C0.750671 16.0854 1.1481 16.25 1.5625 16.25H4.6875C4.6875 16.6644 4.85212 17.0618 5.14515 17.3549C5.43817 17.6479 5.8356 17.8125 6.25 17.8125H9.375C9.375 18.2269 9.53962 18.6243 9.83265 18.9174C10.1257 19.2104 10.5231 19.375 10.9375 19.375H23.4375C23.8519 19.375 24.2493 19.2104 24.5424 18.9174C24.8354 18.6243 25 18.2269 25 17.8125V5.95937C24.9999 5.54501 24.8352 5.14764 24.5422 4.85469L20.7703 1.08281C20.4774 0.789767 20.08 0.625088 19.6656 0.625H10.9375ZM9.375 15.4688V4.53125H7.03125V15.4688H9.375ZM4.6875 13.9062V6.09375H2.34375V13.9062H4.6875Z",
    fill: "#5689A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatorio);
export default __webpack_public_path__ + "static/media/relatorio.346a9aed.svg";
export { ForwardRef as ReactComponent };